export const copyCurrentRouteToClipboard = () => {
  navigator.clipboard.writeText(window.location.href)
}

export const useCurrentRootPath = () => {
  return `/${window.location.pathname.split('/')[1]}`
}

export * from '~/types/RoutingTypes'
